import { render, staticRenderFns } from "./MyOrder.vue?vue&type=template&id=bc1e4406&scoped=true&"
import script from "./MyOrder.vue?vue&type=script&lang=ts&"
export * from "./MyOrder.vue?vue&type=script&lang=ts&"
import style0 from "./MyOrder.vue?vue&type=style&index=0&id=bc1e4406&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1e4406",
  null
  
)

export default component.exports